import { TableBody, TableCell, TableRow, type Theme } from '@mui/material';

interface TableBodyProps {
  rows: Array<{ label: string; value: string | number | null }>;
}

const styles = {
  row: {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: (theme: Theme) => theme.palette.baseColors.cloudGray.c50,
    },
  },
  cell: {
    borderBottom: 'none',
    padding: 'clamp(4px, 0.5vw, 12px)',
    fontSize: 'clamp(8px, 1.2vw, 11px)',
    fontFamily: (theme: Theme) => theme.fonts.inter,
    lineHeight: 1,
  },
};

export const ComponentTableBody = ({ rows }: TableBodyProps) => (
  <TableBody>
    {rows.map(row => (
      <TableRow key={row.label} sx={styles.row}>
        <TableCell sx={styles.cell}>{row.label}</TableCell>
        <TableCell align='right' sx={styles.cell}>
          {row.value}
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);
